<section class="title-info">
    <div class="title-box">
      <div><a href="{{ amaHomeUrl }}" target="_blank"><img src="assets/img/ama-logo.png" /></a></div>
      <div><b>AMA Online Subscriptions</b></div>
    </div>
</section>
<section class="ribbon">
  <div class="layout layout_one_up">
    <nav class="ribbon_dropdown" #mainNav>
      <span class="ribbon_dropdown_trigger"
            [class.is-active]="mainNavActive"
            tabindex="0">
        <span class="menuSpan">MENU</span>
        <span class="menuIconSpan"><mat-icon>menu</mat-icon></span>    
        
        <!--<span class="icon" data-grunticon-embed>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 8 5" style="enable-background:new 0 0 8 5;" xml:space="preserve">
            <path d="M4,5L0.3,1.6c-0.4-0.4-0.4-0.9,0-1.3c0.4-0.4,1-0.4,1.4,0L4,2.4l2.3-2.1c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,0.9,0,1.3L4,5z"/>
            </svg>
        </span>  -->
      </span>

      <ul class="ribbon_dropdown_nav"
          [style.display]="mainNavVisible ? 'block' : 'none'">
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ amaHomeUrl }}">AMA Home</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ amaStoreUrl }}">AMA Store</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ amaWireUrl }}">AMA Wire</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ jamaUrl }}">The JAMA Network</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ freidaUrl }}">FREIDA</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ edHubUrl }}">AMA Ed Hub</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ insuranceUrl }}">AMA Insurance</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ journalOfEthicsUrl }}">AMA Journal of Ethics</a>
        </li>
        <li class="ribbon_dropdown_nav_item">
          <a href="{{ cptUrl }}">CPT</a>
        </li>
      </ul>
    </nav>

    <div class="homeDiv">
      <span class="ribbon_dropdown_trigger">
        <a routerLink="/"><mat-icon matTooltip="Home">arrow_back</mat-icon></a> 
      </span>
    </div>
    <div *ngIf="user" class="ribbon_user-menu">
      <a href="{{ becomeMemberUrl }}"
        *ngIf="!isUserMember && user.groups"
         class="item-hide-on-small member-link bold">
        Become a Member
      </a>

      <nav class="ribbon_dropdown" #userNav>
        <span class="ribbon_user-menu_trigger"
              [class.is-active]="userNavActive"
              tabindex="0">
          <span class="icon icon-right" data-grunticon-embed>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.cls-1{fill:#46166b;}</style></defs><title>human_icon</title><path class="cls-1" d="M0,30S-1.12,17,15,17,30,30,30,30H0Z"/><circle class="cls-1" cx="15" cy="7" r="7"/></svg>
          </span>
        </span>

        <div class="item-hide-on-small">
          <span class="ribbon_dropdown_trigger"
                [class.is-active]="userNavActive"
                tabindex="0">
            {{ user.fullName }} 
            <span class="icon"
                  data-grunticon-embed>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 8 5" style="enable-background:new 0 0 8 5;" xml:space="preserve">
                <path d="M4,5L0.3,1.6c-0.4-0.4-0.4-0.9,0-1.3c0.4-0.4,1-0.4,1.4,0L4,2.4l2.3-2.1c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,0.9,0,1.3L4,5z"/>
                </svg>
            </span>
          </span>
        </div>

        <ul class="ribbon_dropdown_nav ribbon_dropdown_nav-margin-top ribbon_dropdown_nav-right"
            [style.display]="userNavVisible ? 'block' : 'none'">
          <li class="ribbon_dropdown_nav_item usr_first_nav_item">
            <a href="{{ accountManagementCenterUrl }}">Profile</a>
          </li>
          <li class="ribbon_dropdown_nav_item">
            <a href="{{ onlineCodingUrl }}">Go to RBRVS DataManager</a>
          </li>
          <li class="ribbon_dropdown_nav_item">
            <a href="{{ joinRenewUrl }}">Join Renew</a>
          </li>
          <li class="ribbon_dropdown_nav_item">
            <a href="{{ memBenefitsUrl }}">Member Benefits</a>
          </li>

          <li class="ribbon_dropdown_nav_item usr_last_nav_item">
            <a role="button" (click)="logoutUser()">Log out</a>
          </li>
        </ul>
      </nav>
      <div class="cartDiv" *ngIf="displayQuantity"> 
        <div class="ribbon_dropdown_trigger"> 
          <a role="button" (click)="displayCart()">
          <mat-icon matBadge={{cartQuantity}} 
            aria-hidden="false">shopping_cart</mat-icon> <!-- [matBadgeHidden]="!displayQuantity"-->
          </a>
        </div>
      </div>
    </div>

    <div *ngIf="!user" class="ribbon_user-menu">
      <nav class="item-hide-on-small">
        <ul class="clean-list">
          <li class="ribbon_user-menu_nav_item">
            <a href="{{ becomeMemberUrl }}" class="item-hide-on-small bold">Become a Member</a>
          </li>
          <li class="ribbon_user-menu_nav_item">
            <a href="/login">Sign In</a>
          </li>

          <li class="ribbon_user-menu_nav_item">
            <a href="{{ createAccountUrl }}">Create Account</a>
          </li>
        </ul>
      </nav>

      <nav class="item-hide-on-large ribbon_dropdown ribbon_dropdown-unathenticated" #userNav>
        <span class="ribbon_user-menu_trigger"
              [class.is-active]="userNavActive"
              tabindex="0">
          <span class="icon icon-right" data-grunticon-embed>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.cls-1{fill:#46166b;}</style></defs><title>human_icon</title><path class="cls-1" d="M0,30S-1.12,17,15,17,30,30,30,30H0Z"/><circle class="cls-1" cx="15" cy="7" r="7"/></svg>
          </span>
        </span>

        <ul class="ribbon_dropdown_nav ribbon_dropdown_nav-margin-top ribbon_dropdown_nav-right"
          [style.display]="userNavVisible ? 'block' : 'none'">
          <li class="ribbon_dropdown_nav_item">
            <a href="{{ becomeMemberUrl }}">Become a Member</a>
          </li>
          <li class="ribbon_dropdown_nav_item">
            <a href="/login">Sign In</a>
          </li>

          <li class="ribbon_dropdown_nav_item">
            <a href="{{ createAccountUrl }}">Create Account</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</section>
